import * as React from 'react';
import { SpinnerTypes, } from './types';
import { st, classes } from './Spinner.st.css';
class Spinner extends React.Component {
    render() {
        const { className, type, diameter, isCentered, isStatic } = this.props;
        return (React.createElement("svg", { viewBox: "0 0 50 50", className: st(classes.root, { centered: !!isCentered, static: !!isStatic }, className), style: diameter ? {
                width: `${diameter}px`,
                height: `${diameter}px`,
                top: isCentered ? `calc(50% - ${diameter / 2}px)` : 'auto',
                left: isCentered ? `calc(50% - ${diameter / 2}px)` : 'auto',
            } : {}, "data-hook": this.props['data-hook'] },
            React.createElement("circle", { cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: type === SpinnerTypes.regular ? 4 : 1, className: classes.circle })));
    }
}
Spinner.displayName = 'Spinner';
Spinner.defaultProps = {
    type: SpinnerTypes.regular,
    isCentered: false,
    isStatic: false,
};
export { Spinner };
//# sourceMappingURL=Spinner.js.map